import {defineStore} from 'pinia'


export const useCsvStore = defineStore('csvStore', {
  state: () => ({
    chosenCsv: '',
    fileNames: null,
    csvFileData: {},
    columnNames: [],
    chosenColumnForDropdown: '',
    columnDataForDropdown: [],
    matchColumnNames: [],
    chosenCsvRow: {},
    csv: -1
  })
})
